import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { cn } from "ui";

export interface PhoneNumberInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  onChange: (value: string) => void;
  value: string;
  error: boolean;
  disabled?: boolean;
  inputRef: React.LegacyRef<"input">;
}
export default function PhoneNumberInput({
  value,
  onChange,
  error,
  onBlur,
  disabled,
  inputRef,
  id,
  name,
  ...props
}: PhoneNumberInputProps) {
  return (
    <PhoneInput
      inputProps={{ ref: inputRef, id, name, ...props }}
      country={"us"}
      inputStyle={{
        width: "100%",
        borderRadius: "0.375rem",
      }}
      inputClass={cn(
        "peer !border-foundations-bold focus:!border-info-bold text-foundations-boldest placeholder-neutral-500 focus-visible:outline-none focus:ring-info-bold !rounded-md !bg-foundations-default",
        error &&
          "!border-danger-bold focus:!border-danger-bold focus:ring-danger-bold"
      )}
      buttonClass={cn(
        "peer-focus:border-info-bold peer-focus:ring-info-bold !rounded-l-md hover:!rounded-l-md [&>.selected-flag]:!rounded-[inherit] [&>.selected-flag]:!bg-transparent !bg-foundations-default !border-foundations-bold",
        error &&
          "!border-danger-bold focus:!border-danger-bold focus:ring-danger-bold"
      )}
      dropdownClass="!bg-foundations-default [&>.country.highlight]:!bg-foundations-subtlest [&>.country:hover]:!bg-foundations-subtlest"
      preferredCountries={["us", "eg"]}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
    />
  );
}
